module.exports = __webpack_public_path__ + "static/media/ham-menu-close.43d037c1.svg";